var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomHouse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.533 13.7 15.8 3.919a1.24 1.24 0 0 0-1.66 0l-10.733 9.78a1.22 1.22 0 0 0-.324 1.357 1.2 1.2 0 0 0 1.134.79h1.721v9.801c0 .385.324.709.71.709h5.892a.717.717 0 0 0 .709-.709v-5.953h3.462v5.953c0 .385.324.709.71.709h5.892a.717.717 0 0 0 .709-.709v-9.8h1.72a1.2 1.2 0 0 0 1.135-.79 1.3 1.3 0 0 0-.344-1.357z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.799 5.012H19.08l5.427 4.941V5.721a.704.704 0 0 0-.71-.709z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-house.b78cf88cfd947592eaafad66138031b8.svg";